
function formatTitleFromFilter(currentFilter, entities, totalRecords, dataFilterNormaliced) {

    let title = ""
    let especie = "Animales", raza = "", sexo = "", edad = "", tamano = ""

    especie = dataFilterNormaliced.especie
    raza = dataFilterNormaliced.raza
    sexo = (dataFilterNormaliced.sexo) ? dataFilterNormaliced.sexo : ""
    edad = (dataFilterNormaliced.edad) ? dataFilterNormaliced.edad : ""

    title = `${totalRecords} ${raza || especie} ${sexo} ${edad} en adopción`

    return title
}

function isMongoId(str) {
    return (typeof str === 'string' && /^[0-9A-F]+$/i.test(str) && str.length === 24);
}

export default {
    isMongoId: isMongoId,
}

